/* eslint-disable no-unused-expressions */
import Vue from 'vue'
import MiniAuthTrigger from './mini-auth-trigger.vue'

let isInstantiated = null

function observerInstance(instance, options) {
  instance.$on('onCancel', (...args) => {
    isInstantiated = false
    options?.onCancel.call(instance, ...args)
  })
  instance.$on('onConfirm', (...args) => {
    isInstantiated = false
    options?.onConfirm.call(instance, ...args)
  })
}

const MiniAuthTriggerConstructor = Vue.extend(MiniAuthTrigger)

// eslint-disable-next-line space-before-function-paren
MiniAuthTrigger.install = function (options = {}) {
  if (isInstantiated) {
    return false
  }
  isInstantiated = true
  const instance = new MiniAuthTriggerConstructor({
    propsData: options
  }).$mount()
  observerInstance(instance, options)
  document.body.appendChild(instance.$el)
}

export default MiniAuthTrigger
